import React from "react";
import Container from "../../../utils/Container";
import chairman from "../../../assets/chairman.jpeg";
const AboutUs = () => {
  return (
    <Container>
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-14">
            <h1 className="text-4xl font-bold text-gray-800 mb-3">
              About <span className="text-blue-600">Dhoorbin.com</span>
            </h1>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">
              Dhoorbin.com: Your trusted travel companion. We are not just a
              booking platform; we ensure real presence, real support, and real
              experience throughout your journey.
            </p>
          </div>

          <div className="bg-white shadow-lg rounded-2xl p-8 mb-12">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              1. Our Vision & Mission
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Our primary goal is to build a “one-stop travel solution” for the
              travelers of Bangladesh. By combining technology with human touch,
              we aim to make your journey smooth, safe, and enjoyable. Our
              responsibility does not end at booking — we stay with you until
              you reach your destination and return home safely.
            </p>
          </div>

          <div className="bg-white shadow-lg rounded-2xl p-8 mb-12">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              2. Our Services
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              From start to finish — we provide everything needed for your trip:
            </p>

            <ul className="grid sm:grid-cols-2 gap-6 text-gray-700">
              <li className="flex items-start gap-3">
                <span className="text-blue-600 text-xl">•</span>
                <p>
                  <strong>Hotel & Resort Booking:</strong> Luxury hotels to
                  budget-friendly eco resorts.
                </p>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-blue-600 text-xl">•</span>
                <p>
                  <strong>Transportation:</strong> AC/Non-AC bus tickets and
                  private car rental services.
                </p>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-blue-600 text-xl">•</span>
                <p>
                  <strong>Tour Packages & Guides:</strong> Custom tour plans
                  with experienced guides.
                </p>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-blue-600 text-xl">•</span>
                <p>
                  <strong>On-Spot Support:</strong> Immediate assistance during
                  your trip.
                </p>
              </li>
            </ul>
          </div>

          <div className="bg-white shadow-lg rounded-2xl p-8 mb-12">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              3. Why Choose Us?
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              Dhoorbin.com is different from other Online Travel Agencies (OTAs)
              because:
            </p>

            <ul className="space-y-4 text-gray-700">
              <li className="flex gap-3">
                <span className="text-blue-600 text-xl">✔</span>
                <p>
                  <strong>Physical + Digital Service:</strong> We have real
                  Customer Service Points in tourist spots.
                </p>
              </li>
              <li className="flex gap-3">
                <span className="text-blue-600 text-xl">✔</span>
                <p>
                  <strong>Live Supervision:</strong> If there's any issue at the
                  hotel, our representatives handle it instantly.
                </p>
              </li>
              <li className="flex gap-3">
                <span className="text-blue-600 text-xl">✔</span>
                <p>
                  <strong>Real Experience:</strong> What we show online is what
                  you get in reality.
                </p>
              </li>
            </ul>
          </div>

          <div className="bg-white shadow-lg rounded-2xl p-8 mb-12">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              4. Our Commitment
            </h2>
            <ul className="space-y-4 text-gray-700">
              <li className="flex gap-3">
                <span className="text-blue-600 text-xl">•</span>
                <p>
                  <strong>Reliability:</strong> Your booking & payment are 100%
                  secure.
                </p>
              </li>
              <li className="flex gap-3">
                <span className="text-blue-600 text-xl">•</span>
                <p>
                  <strong>Quality Assurance:</strong> We ensure you receive
                  exactly what you booked.
                </p>
              </li>
              <li className="flex gap-3">
                <span className="text-blue-600 text-xl">•</span>
                <p>
                  <strong>24/7 Support:</strong> Anytime, any need — we are here
                  to help.
                </p>
              </li>
            </ul>
          </div>

          <div className="bg-white shadow-lg rounded-2xl p-8 mb-16">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              5. Why Stay Connected?
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              Travel means discovery — and Dhoorbin.com is your guide to that
              discovery.
            </p>

            <ul className="space-y-4 text-gray-700">
              <li className="flex gap-3">
                <span className="text-blue-600 text-xl">⭐</span>
                <p>
                  <strong>Exclusive Deals:</strong> Seasonal offers, discounts,
                  and loyalty rewards.
                </p>
              </li>
              <li className="flex gap-3">
                <span className="text-blue-600 text-xl">⭐</span>
                <p>
                  <strong>Travel Tips & Updates:</strong> Stay updated with new
                  destinations & travel hacks.
                </p>
              </li>
              <li className="flex gap-3">
                <span className="text-blue-600 text-xl">⭐</span>
                <p>
                  <strong>Easy Solutions:</strong> Plan your next tour
                  effortlessly with us.
                </p>
              </li>
            </ul>
          </div>

          <div className="bg-white shadow-xl rounded-2xl p-10 md:flex items-center gap-10">
            <div className="md:w-1/3 mb-8 md:mb-0">
              <img
                src={chairman}
                alt="Chairman"
                className="w-full rounded-xl shadow-md"
              />
            </div>

            <div className="md:w-2/3">
              <h2 className="text-3xl font-bold text-gray-800 mb-4">
                CEO Message
              </h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                At Dhoorbin.com, our mission is to bring trust, transparency,
                and real support to the travel industry of Bangladesh. We
                believe traveling should never feel complicated — it should feel
                exciting, inspiring, and secure.
              </p>
              <p className="text-gray-600 leading-relaxed mb-4">
                We built this platform to combine technology with a human touch,
                ensuring that every traveler feels guided and cared for from the
                moment they book until they return home safely.
              </p>
              <p className="text-gray-800 font-semibold">
                Akramul Bashar Chowdhury
              </p>
            </div>
          </div>
        </div>
      </section>
    </Container>
  );
};

export default AboutUs;
